import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsPorscheComponent } from './simple-icons-porsche.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsPorscheComponent ],
    exports:      [ SimpleIconsPorscheComponent ],
    bootstrap:    []
})
export class SimpleIconsPorscheModule {}
